// extracted by mini-css-extract-plugin
export var statItem = "_gf-1";
export var statsRow = "_gf-0";